import { convertUnit, SharedserviceMelcoModelsDesignListItem } from "melco-shared-logic";

type DisplayDesignSizeProps = {
  design: SharedserviceMelcoModelsDesignListItem;
  measurementUnit: string | undefined;
};

export const DisplayDesignSize: React.FC<DisplayDesignSizeProps> = ({
  design,
  measurementUnit,
}) => {
  const { width, height, unit } = design;

  if (!width || !height || !unit || unit.toLowerCase() !== "points") {
    return null;
  }

  const targetUnit = measurementUnit === "english" ? "inch" : "mm";

  return (
    <>
      {`${convertUnit({ value: width, from: "points", to: targetUnit }).toFixed(
        2
      )} x ${convertUnit({
        value: height,
        from: "points",
        to: targetUnit,
      }).toFixed(2)} ${targetUnit}`}{" "}
    </>
  );
};
